export const NoContent = () => (
  <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '150px' }}>
    <h2 className="sub-header-title">No content added yet</h2>
    <span className="text-gray-500 mt-2">Share updates, ask questions, or start a discussion.</span>
  </div>
);
